var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass:
        "painel-anel-progresso d-inline-flex align-center justify-center flex-shrink-0",
      attrs: {
        role: "img",
        "aria-label": _vm.rotulo,
        title: _vm.rotulo,
        "data-test": "painel-anel-progresso"
      }
    },
    [
      _vm.concluido
        ? _c("icon-svg", {
            attrs: {
              name: _vm.ICONE_DE_CONCLUIDO,
              size: _vm.LADO_DO_ANEL,
              color: "primary",
              "data-test": "painel-anel-progresso-concluido"
            }
          })
        : _c(
            "svg",
            {
              staticClass: "painel-anel-progresso__svg",
              class: {
                "painel-anel-progresso__svg--girando": _vm.indeterminado
              },
              attrs: {
                width: _vm.LADO_DO_ANEL,
                height: _vm.LADO_DO_ANEL,
                viewBox: _vm.viewBox,
                "aria-hidden": "true",
                "data-test": "painel-anel-progresso-svg"
              }
            },
            [
              _c("circle", {
                staticClass: "painel-anel-progresso__trilha",
                attrs: {
                  cx: _vm.centro,
                  cy: _vm.centro,
                  r: _vm.RAIO_DO_ANEL,
                  "stroke-width": _vm.TRACO_DO_ANEL,
                  fill: "none"
                }
              }),
              _c("circle", {
                staticClass: "painel-anel-progresso__arco",
                class: {
                  "painel-anel-progresso__arco--trabalhando": _vm.trabalhando
                },
                attrs: {
                  cx: _vm.centro,
                  cy: _vm.centro,
                  r: _vm.RAIO_DO_ANEL,
                  "stroke-width": _vm.TRACO_DO_ANEL,
                  "stroke-dasharray": _vm.tracejado,
                  fill: "none",
                  "stroke-linecap": "round",
                  "data-test": "painel-anel-progresso-arco"
                }
              }),
              _vm.trabalhando
                ? _c("circle", {
                    staticClass: "painel-anel-progresso__ponta",
                    attrs: {
                      cx: _vm.pontaDoArco.x,
                      cy: _vm.pontaDoArco.y,
                      r: _vm.TRACO_DO_ANEL,
                      "data-test": "painel-anel-progresso-ponta"
                    }
                  })
                : _vm._e()
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }